import {Flex, Text} from '@chakra-ui/react';

import {useTranslate} from '@eksab/i18n';

import {BallIcon} from './icons';

export const NoStats = () => {
  const t = useTranslate();

  return (
    <Flex flexDir="column" align="center" gap="4" py="1" textAlign="center">
      <BallIcon opacity="0.4" />

      <Text as="span" color="gray.800" fontSize="sm" fontWeight="700">
        {t('fantasy.lineup.stats.no-stats')}
      </Text>
    </Flex>
  );
};
